import { DependencyHelper } from '../../../../dependency/helpers/DependencyHelper';
import { _get } from '../../../../immutable';
import { noCodeBuildDependencyGraphParams } from '../../../context/DependencyGraphProvider/builders';
import noCodeBuildDependencyGraph from '../../../dependency/noCodeBuildDependencyGraph';
import DataSourceHelper from '../../../helper/DataSourceHelper';
import { useDSCGetComputeContext } from '../context/selectors';

const TRANSFORMER_CODE_OBJECT_ID = 'transformer-code';

function transformerDependencyBuilder({ transformerCode }: { transformerCode: string }) {
  const dependencyGraph = noCodeBuildDependencyGraph({
    objects: {
      [TRANSFORMER_CODE_OBJECT_ID]: {
        code: transformerCode,
      },
    },
    ...noCodeBuildDependencyGraphParams,
  });

  return dependencyGraph;
}

/**
 * This hook helps us find all the pills picked by the user in the transformation code, after we figure out the pills we return an object
 * with the key as the pill path against the value stored in the context
 */
export function useBuildTransformerParameters({ transformerCode }: { transformerCode?: string }) {
  const getComputeContext = useDSCGetComputeContext();

  if (!DataSourceHelper.isTransformerConfigured(transformerCode) || !transformerCode) {
    return;
  }

  const computeContext = getComputeContext();
  const dependencyGraph = transformerDependencyBuilder({ transformerCode })[
    TRANSFORMER_CODE_OBJECT_ID
  ];
  const dependsOn = DependencyHelper.getCombinedDependsOnProperties(dependencyGraph?.dependsOn);

  const uniquePaths = new Set(dependsOn);

  const transformerParameters = Array.from(uniquePaths).reduce(
    (acc, path) => {
      const value = _get(computeContext, path) ?? undefined;
      acc[path] = value;
      return acc;
    },
    {} as Record<string, unknown>,
  );

  return transformerParameters;
}
